import './viz.css'

interface PipStripProps {
  pips: Array<'ok' | 'fail' | 'warn' | 'empty' | 'off'>
  ariaLabel: string
}

/**
 * Row of status pips, one per entry, e.g. recent run outcomes. Wraps when narrow.
 * `empty` is a placeholder for an entry that does not exist yet and is drawn almost
 * as the background; `off` is an entry that exists and is switched off (a closed
 * gate), drawn as a muted pip that still reads against the card.
 */
export function PipStrip({ pips, ariaLabel }: PipStripProps) {
  return (
    <div className="viz-pips" role="img" aria-label={ariaLabel}>
      {pips.map((state, i) => (
        <span key={i} className={`viz-pip viz-pip--${state}`} />
      ))}
    </div>
  )
}
